/**
 * CZNA-1432 — what a review action will do, readable before the click.
 *
 * The labels alone do not tell the review actions apart: Schválit and Postoupit NK both mean
 * "locally fine" and differ only in whether NK sees the record, and Navrhnout změnu sits in
 * the same row without settling the review at all. Until this, the only description of an action was its success message.
 *
 * A thin wrapper over `HelpTooltip` (the module's click-to-open "otazníček", keyboard
 * reachable) that names its trigger after the action — a row of several identical
 * "Nápověda" buttons would not say which one belongs to which action.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import HelpTooltip from '../HelpTooltip';
var ActionHelp = function (_a) {
    var testKey = _a.testKey, labelId = _a.labelId, helpId = _a.helpId, helpValues = _a.helpValues;
    var intl = useIntl();
    return (React.createElement(HelpTooltip, { idPrefix: "action-help", testKey: testKey, messageId: helpId, messageValues: helpValues, ariaLabel: intl.formatMessage({ id: 'ui-czna-authorities.actionHelp.ariaLabel' }, { action: intl.formatMessage({ id: labelId }) }) }));
};
export default ActionHelp;
